/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerVoiceTicketCreateRequest } from '../models/CustomerVoiceTicketCreateRequest';
import type { CustomerVoiceTicketTransitionRequest } from '../models/CustomerVoiceTicketTransitionRequest';
import type { SuccessResponse_CustomerVoiceTicketListResponse_ } from '../models/SuccessResponse_CustomerVoiceTicketListResponse_';
import type { SuccessResponse_CustomerVoiceTicketResponse_ } from '../models/SuccessResponse_CustomerVoiceTicketResponse_';
import type { SuccessResponse_TableVisitHistoryResponse_ } from '../models/SuccessResponse_TableVisitHistoryResponse_';
import type { SuccessResponse_TableVisitRecordResponse_ } from '../models/SuccessResponse_TableVisitRecordResponse_';
import type { SuccessResponse_TableVisitTodayResponse_ } from '../models/SuccessResponse_TableVisitTodayResponse_';
import type { TableVisitCreateRequest } from '../models/TableVisitCreateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomerVoiceService {
    /**
     * Create Table Visit Endpoint
     * @returns SuccessResponse_TableVisitRecordResponse_ Successful Response
     * @throws ApiError
     */
    public static createTableVisitEndpointApiV1TableVisitsPost({
        requestBody,
    }: {
        requestBody: TableVisitCreateRequest,
    }): CancelablePromise<SuccessResponse_TableVisitRecordResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/table-visits',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Table Visits Today Endpoint
     * @returns SuccessResponse_TableVisitTodayResponse_ Successful Response
     * @throws ApiError
     */
    public static getTableVisitsTodayEndpointApiV1TableVisitsTodayGet({
        storeId,
        mine = false,
    }: {
        storeId?: (number | null),
        mine?: boolean,
    }): CancelablePromise<SuccessResponse_TableVisitTodayResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/table-visits/today',
            query: {
                'store_id': storeId,
                'mine': mine,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Table Visit History Endpoint
     * 历史桌访 (2026-07-09): 默认近 30 天; 权限语义与 today 端点一致。
     * @returns SuccessResponse_TableVisitHistoryResponse_ Successful Response
     * @throws ApiError
     */
    public static getTableVisitHistoryEndpointApiV1TableVisitsHistoryGet({
        dateFrom,
        dateTo,
        storeId,
        satisfaction,
        mine = false,
        limit = 100,
    }: {
        dateFrom?: (string | null),
        dateTo?: (string | null),
        storeId?: (number | null),
        satisfaction?: (string | null),
        mine?: boolean,
        limit?: number,
    }): CancelablePromise<SuccessResponse_TableVisitHistoryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/table-visits/history',
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
                'store_id': storeId,
                'satisfaction': satisfaction,
                'mine': mine,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Customer Voice Ticket Endpoint
     * @returns SuccessResponse_CustomerVoiceTicketResponse_ Successful Response
     * @throws ApiError
     */
    public static createCustomerVoiceTicketEndpointApiV1CustomerVoiceTicketsPost({
        requestBody,
    }: {
        requestBody: CustomerVoiceTicketCreateRequest,
    }): CancelablePromise<SuccessResponse_CustomerVoiceTicketResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/customer-voice/tickets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Customer Voice Tickets Endpoint
     * @returns SuccessResponse_CustomerVoiceTicketListResponse_ Successful Response
     * @throws ApiError
     */
    public static listCustomerVoiceTicketsEndpointApiV1CustomerVoiceTicketsGet({
        status,
        sourceType,
        storeId,
        limit = 50,
    }: {
        status?: ('active' | 'open' | 'acknowledged' | 'processing' | 'replied' | 'resolved' | 'closed' | 'voided' | null),
        sourceType?: ('public_review' | 'table_visit' | 'table_visit_alert' | null),
        storeId?: (number | null),
        limit?: number,
    }): CancelablePromise<SuccessResponse_CustomerVoiceTicketListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/customer-voice/tickets',
            query: {
                'status': status,
                'source_type': sourceType,
                'store_id': storeId,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Customer Voice Ticket Endpoint
     * @returns SuccessResponse_CustomerVoiceTicketResponse_ Successful Response
     * @throws ApiError
     */
    public static getCustomerVoiceTicketEndpointApiV1CustomerVoiceTicketsTicketIdGet({
        ticketId,
    }: {
        ticketId: number,
    }): CancelablePromise<SuccessResponse_CustomerVoiceTicketResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/customer-voice/tickets/{ticket_id}',
            path: {
                'ticket_id': ticketId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transition Customer Voice Ticket Endpoint
     * @returns SuccessResponse_CustomerVoiceTicketResponse_ Successful Response
     * @throws ApiError
     */
    public static transitionCustomerVoiceTicketEndpointApiV1CustomerVoiceTicketsTicketIdTransitionPatch({
        ticketId,
        requestBody,
    }: {
        ticketId: number,
        requestBody: CustomerVoiceTicketTransitionRequest,
    }): CancelablePromise<SuccessResponse_CustomerVoiceTicketResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/customer-voice/tickets/{ticket_id}/transition',
            path: {
                'ticket_id': ticketId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
